"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const React = __importStar(require("react"));
const styles_1 = require("@mui/material/styles");
const ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
const react_router_dom_1 = require("react-router-dom");
const Box_1 = __importDefault(require("@mui/material/Box"));
const material_1 = require("@mui/material");
const KeyboardArrowIcon_1 = __importDefault(require("./KeyboardArrowIcon"));
const MobileTheme_1 = __importDefault(require("./MobileTheme"));
const themes_1 = require("../../../themes");
const eqMainTheme_1 = require("../../../themes/eqMainTheme");
const SvgIcon = (0, styles_1.styled)('img')(() => ({
    width: 24,
    height: 24,
    objectFit: 'contain',
}));
const MobileMenuItem = ({ linkConfig, isBottomMenu, toggleDrawer, onClick, isOpen, themeVariant, isAccountLink, }) => {
    const th = (0, MobileTheme_1.default)(themeVariant);
    const location = (0, react_router_dom_1.useLocation)();
    const { icon, iconUrl, url, subLinks, label, externalUrl, disabled } = linkConfig;
    const DrawIcon = icon;
    const isLinkActive = url
        ? location.pathname.indexOf(url) >= 0
        : subLinks === null || subLinks === void 0 ? void 0 : subLinks.some((link) => location.pathname.indexOf(link.url) >= 0);
    const highlight = isOpen || isLinkActive;
    const handleClick = (e) => {
        if (onClick)
            onClick(e);
        if (url)
            toggleDrawer();
    };
    const handleClose = () => {
        toggleDrawer();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ListItem_1.default, Object.assign({ button: true }, {
            href: externalUrl ? url : undefined,
            to: !externalUrl ? url : undefined,
            component: externalUrl || subLinks ? 'a' : react_router_dom_1.Link,
        }, { onClick: handleClick, "aria-controls": "mobile-menu", "aria-haspopup": "true", "aria-expanded": isOpen ? 'true' : undefined, disabled: disabled, sx: {
                borderLeft: highlight ? `4px solid ${th.itemLeftBorder}` : 'none',
                backgroundColor: highlight ? th.item : th.backgroundColor,
                '&:hover': {
                    backgroundColor: highlight ? th.item : th.backgroundColor,
                },
            } }),
            React.createElement(ListItemText_1.default, { sx: {
                    marginLeft: isOpen ? '20px' : themes_1.Spacings.small4,
                    marginTop: themes_1.Spacings.small2,
                    marginBottom: themes_1.Spacings.small2,
                }, primary: React.createElement(Box_1.default, { sx: {
                        fontFamily: isBottomMenu
                            ? 'Avenir LT W01_65 Medium1475532'
                            : 'Avenir LT W01_85 Heavy1475544',
                        letterSpacing: '-0.2px',
                        display: 'flex',
                        justifyContent: isBottomMenu ? 'normal' : 'space-between',
                    } },
                    icon && (React.createElement(ListItemIcon_1.default, null,
                        React.createElement(DrawIcon, null))),
                    iconUrl && (React.createElement(ListItemIcon_1.default, { sx: { '&.custom-icon': { minWidth: 40 } }, classes: { root: 'custom-icon' } },
                        React.createElement(SvgIcon, { src: iconUrl, alt: label }))),
                    React.createElement(material_1.Typography, { variant: "h6Light", sx: isAccountLink ? { fontFamily: eqMainTheme_1.fonts.Roman } : {} },
                        label,
                        ' '),
                    (subLinks === null || subLinks === void 0 ? void 0 : subLinks.length) && (React.createElement(KeyboardArrowIcon_1.default, { isOpen: isOpen, style: {
                            width: 24,
                            marginRight: 24,
                            filter: th.iconFilter,
                        } }))) })),
        (subLinks === null || subLinks === void 0 ? void 0 : subLinks.length) &&
            isOpen &&
            subLinks.map((link, i) => (React.createElement(ListItem_1.default, Object.assign({ sx: {
                    borderLeft: `4px solid ${th.itemLeftBorder}`,
                    backgroundColor: th.item,
                    paddingLeft: themes_1.Spacings.small4,
                    paddingTop: themes_1.Spacings.small2,
                    paddingBottom: i === subLinks.length - 1 ? themes_1.Spacings.small3 : themes_1.Spacings.small2,
                    marginBottom: i === subLinks.length - 1 ? themes_1.Spacings.small2 : 0,
                    '&:hover': {
                        backgroundColor: th.item,
                    },
                }, classes: { container: 'sub-item-margin' }, button: true }, {
                href: link.externalUrl ? link.url : undefined,
                to: !link.externalUrl ? link.url : undefined,
                component: link.externalUrl ? 'a' : react_router_dom_1.Link,
            }, { key: link.label, onClick: handleClose, "aria-controls": "mobile-menu", "aria-haspopup": "true", "aria-expanded": isOpen ? 'true' : undefined }),
                React.createElement(ListItemText_1.default, { sx: {
                        marginLeft: themes_1.Spacings.medium2,
                        fontFamily: 'Avenir LT W01_65 Medium1475532',
                        letterSpacing: '-0.2px',
                    }, primary: React.createElement(material_1.Typography, { variant: "body5Medium" }, link.label) }))))));
};
exports.default = MobileMenuItem;
